import * as actions from "../action.constants";

const requestEventRules = (pageUrl) => ({
  type: actions.REQUEST_EVENT_RULES,
  pageUrl,
});

const saveEventRules = (data) => ({
  type: actions.SAVE_EVENT_RULES,
  payload: data,
});

const createUpdateEventRule = (data, callback, onError) => ({
  type: actions.CREATE_UPDATE_EVENT_RULE,
  payload: data,
  callback,
  onError,
});

const deleteEventRule = (id, callback) => ({
  type: actions.DELETE_EVENT_RULE,
  payload: id,
  callback,
});
const requestContentTypes = () => ({
  type: actions.REQUEST_CONTENT_TYPES,
});

const saveContentTypes = (data) => ({
  type: actions.SAVE_CONTENT_TYPES,
  payload: data,
});
const requestEventFieldTypes = () => ({
  type: actions.REQUEST_EVENT_FIELD_TYPES,
});

const saveEventFieldTypes = (data) => ({
  type: actions.SAVE_EVENT_FIELD_TYPES,
  payload: data,
});

const requestEventWebhooks = () => ({
  type: actions.REQUEST_EVENT_WEBHOOKS,
});

const saveEventWebhooks = (data) => ({
  type: actions.SAVE_EVENT_WEBHOOKS,
  payload: data,
});
export {
  requestEventRules,
  saveEventRules,
  createUpdateEventRule,
  deleteEventRule,
  requestContentTypes,
  saveContentTypes,
  requestEventFieldTypes,
  saveEventFieldTypes,
  requestEventWebhooks,
  saveEventWebhooks,
};
